export const WISHLIST_ACTIONS = {
  ADD: 'add',
  REMOVE: 'remove'
};
